// CV education/employment use month precision; birth dates remain full dates.
export const fullRecordDate=value=>{
 const date=String(value||'').slice(0,10);
 return /^\d{4}-\d{2}-\d{2}$/.test(date)&&Number(date.slice(0,4))>=1900&&!isNaN(Date.parse(date))&&new Date(date+'T00:00:00Z').toISOString().slice(0,10)===date;
};
export const validRecordMonth=value=>/^\d{4}-(0[1-9]|1[0-2])$/.test(String(value||''))&&Number(String(value).slice(0,4))>=1900;
export const validRecordDate=value=>validRecordMonth(value)||fullRecordDate(value);
export const monthValue=value=>validRecordDate(value)?String(value).slice(0,7):'';
export function currentRecordMonth(now=new Date()){
 const parts=new Intl.DateTimeFormat('en',{timeZone:'Europe/Istanbul',year:'numeric',month:'2-digit'}).formatToParts(now);
 return parts.find(x=>x.type==='year').value+'-'+parts.find(x=>x.type==='month').value;
}
export function displayRecordMonth(value,lang='tr'){
 const month=monthValue(value);if(!month)return '';
 return new Intl.DateTimeFormat(lang==='sr'?'sr-Latn':lang,{month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(month+'-01T00:00:00Z'));
}
// Existing API/SQL contract is DateTime. New month selections use day 01 as a
// transport convention, not a day the candidate claimed to remember.
export const apiRecordDate=value=>validRecordMonth(value)?value+'-01':value?String(value).slice(0,10):null;
export function recordPeriod(start,end){
 let baslangic=apiRecordDate(start),bitis=apiRecordDate(end);
 // When a legacy day and a newly selected month meet in the same month, keep
 // the range valid for the DateTime API. Untouched full-date pairs stay intact.
 if(baslangic&&bitis&&baslangic>bitis&&monthValue(start)===monthValue(end)&&(validRecordMonth(start)||validRecordMonth(end))){baslangic=monthValue(start)+'-01';bitis=monthValue(end)+'-01';}
 return {baslangic,bitis};
}
export const recordPeriodValid=(start,end)=>monthValue(end)>=monthValue(start)&&(!(fullRecordDate(start)&&fullRecordDate(end))||apiRecordDate(end)>=apiRecordDate(start));
